'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Days = require('./Days');

var _Days2 = _interopRequireDefault(_Days);

var _dateProptype = require('../date-proptype');

var _dateProptype2 = _interopRequireDefault(_dateProptype);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @fileOverview ReactComponent for displaying a Month.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author jzetlen
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @memberof component-datepicker
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @function Month
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * A calendar month UI that displays a header for the month currently showing,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * "previous" and "next" navigation links, and a table of clickable days. It will
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * also apply special styles based on date validity and the current `startDate`
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * and `endDate`.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **/


/**
 * @class MonthNavigator
 * @memberof component-datepicker
 * A component that displays the top navigator for a Month UI. Displays a
 * previous link, a month name, and a next link. Takes handlers for these links
 * and autogenerates the requested month, sending it as a parameter with
 * handler invocations.
 */
var MonthNavigator = function (_Component) {
	_inherits(MonthNavigator, _Component);

	function MonthNavigator() {
		_classCallCheck(this, MonthNavigator);

		return _possibleConstructorReturn(this, (MonthNavigator.__proto__ || Object.getPrototypeOf(MonthNavigator)).apply(this, arguments));
	}

	_createClass(MonthNavigator, [{
		key: 'render',
		value: function render() {
			var props = this.props;

			// create previous and next months for sending in click handlers
			var currentYear = props.showMonth.getFullYear(),
			    currentMonth = props.showMonth.getMonth(),
			    previousMonth = new Date(currentYear, currentMonth),
			    nextMonth = new Date(currentYear, currentMonth);
			nextMonth.setMonth(currentMonth + 1);
			previousMonth.setMonth(currentMonth - 1);

			// create bound click handlers
			var onClickPrev = function onClickPrev(e) {
				return props.onClickPrev(e, previousMonth);
			},
			    onClickNext = function onClickNext(e) {
				return props.onClickNext(e, nextMonth);
			},
			    onClickMonthName = function onClickMonthName(e) {
				return props.onClickMonthName(e, props.showMonth);
			};

			// create css classnames combining required classnames and passed props
			var prevClassName = ['prev', props.prevLinkClassName || ''].join(' '),
			    nextClassName = ['next', props.nextLinkClassName || ''].join(' '),
			    monthHeaderClassName = ['month-name', props.monthHeaderClassName || ''].join(' ');

			return _react2.default.createElement(
				'tr',
				{ className: 'caption' },
				_react2.default.createElement(
					'th',
					{ onClick: onClickPrev, className: 'prev-container' },
					_react2.default.createElement(
						'span',
						{ className: prevClassName },
						'<'
					)
				),
				_react2.default.createElement(
					'th',
					{ className: monthHeaderClassName, colSpan: '5' },
					_react2.default.createElement(
						'span',
						{ onClick: props.onClickMonthName },
						props.formatMonthHeader(props.showMonth)
					)
				),
				_react2.default.createElement(
					'th',
					{ onClick: onClickNext, className: 'next-container' },
					_react2.default.createElement(
						'span',
						{ className: nextClassName },
						'>'
					)
				)
			);
		}
	}]);

	return MonthNavigator;
}(_react.Component);

/**
 * @class WeekHeader
 * @memberof component-datepicker
 * A component that displays a table row with localized day-of-week headings.
 * Respects a `startOfWeek` prop and takes its day names from a `labels` prop.
 */


var WeekHeader = function (_Component2) {
	_inherits(WeekHeader, _Component2);

	function WeekHeader() {
		_classCallCheck(this, WeekHeader);

		return _possibleConstructorReturn(this, (WeekHeader.__proto__ || Object.getPrototypeOf(WeekHeader)).apply(this, arguments));
	}

	_createClass(WeekHeader, [{
		key: 'render',
		value: function render() {
			var _props = this.props,
			    labels = _props.labels,
			    startOfWeek = _props.startOfWeek;
			// these awkward week header labels are from the previous API,
			// maintained for compatibility with the existing localization data.
			// TODO: change them to be better.

			var dayLabels = [labels['week-7'], // in javascript, sunday is day 0
			labels['week-1'], labels['week-2'], labels['week-3'], labels['week-4'], labels['week-5'], labels['week-6']];
			// if sunday is first, pop it off the end and push it on the beginning
			var weekOffset = startOfWeek;
			while (weekOffset-- > 0) {
				dayLabels.push(dayLabels.shift());
			}
			return _react2.default.createElement(
				'tr',
				{ className: 'week-name' },
				dayLabels.map(function (label) {
					return _react2.default.createElement(
						'th',
						{ key: label },
						label
					);
				})
			);
		}
	}]);

	return WeekHeader;
}(_react.Component);

var Month = function (_Component3) {
	_inherits(Month, _Component3);

	function Month() {
		_classCallCheck(this, Month);

		return _possibleConstructorReturn(this, (Month.__proto__ || Object.getPrototypeOf(Month)).apply(this, arguments));
	}

	_createClass(Month, [{
		key: 'render',
		value: function render() {
			var props = this.props;
			return _react2.default.createElement(
				'div',
				{ className: 'month-wrapper' },
				_react2.default.createElement(
					'table',
					{ className: 'month1',
						style: { cellSpacing: '0',
							border: '0',
							cellPadding: '0' } },
					_react2.default.createElement(
						'thead',
						null,
						_react2.default.createElement(MonthNavigator, {
							monthHeaderClassName: props.monthHeaderClassName,
							prevLinkClassName: props.prevLinkClassName,
							nextLinkClassName: props.nextLinkClassName,
							formatMonthHeader: props.formatMonthHeader,
							showMonth: props.showMonth,
							onClickPrev: props.onClickPrev,
							onClickMonthName: props.onClickMonthName,
							onClickNext: props.onClickNext,
							labels: props.labels
						}),
						_react2.default.createElement(WeekHeader, {
							labels: props.labels,
							startOfWeek: props.startOfWeek
						})
					),
					_react2.default.createElement(_Days2.default, {
						month: props.showMonth,
						startDate: props.startDate,
						endDate: props.endDate,
						startOfWeek: props.startOfWeek,
						onClickDay: props.onClickDay,
						onHoverDay: props.onHoverDay,
						validateDate: props.validateDate,
						dayClassName: props.dayClassName
					})
				)
			);
		}
	}]);

	return Month;
}(_react.Component);

exports.default = Month;
var string = _react.PropTypes.string,
    shape = _react.PropTypes.shape,
    func = _react.PropTypes.func,
    oneOf = _react.PropTypes.oneOf;

Month.propTypes = {
	monthHeaderClassName: string,
	prevLinkClassName: string,
	nextLinkClassName: string,
	onClickPrev: func,
	onClickNext: func,
	onClickMonthName: func,
	formatMonthHeader: func.isRequired,
	showMonth: _dateProptype2.default.isRequired,
	startDate: _dateProptype2.default.isRequired,
	endDate: _dateProptype2.default.isRequired,
	startOfWeek: oneOf([0, 1, 2, 3, 4, 5, 6]),
	labels: shape({
		'week-1': string.isRequired,
		'week-2': string.isRequired,
		'week-3': string.isRequired,
		'week-4': string.isRequired,
		'week-5': string.isRequired,
		'week-6': string.isRequired,
		'week-7': string.isRequired
	}),
	validateDate: func.isRequired,
	dayClassName: string
};

Month.defaultProps = {
	startOfWeek: 0,
	validateDate: function validateDate() {
		return true;
	}
};


//////////////////
// WEBPACK FOOTER
// /causemisspiggynodeweb-ci-9188/workspace/Release/~/component-datepicker/dist/components/Month.js
// module id = 507
// module chunks = 0